import {
    aggregationFn_count,
    aggregationFn_sum,
    cellSelectionFeature,
    columnFilteringFeature,
    columnGroupingFeature,
    columnOrderingFeature,
    columnPinningFeature,
    columnResizingFeature,
    columnSizingFeature,
    columnVisibilityFeature,
    createExpandedRowModel,
    createFilteredRowModel,
    createGroupedRowModel,
    createPaginatedRowModel,
    createSortedRowModel,
    filterFn_arrHas,
    filterFn_equalsString,
    filterFn_includesString,
    globalFilteringFeature,
    metaHelper,
    rowAggregationFeature,
    rowExpandingFeature,
    rowPaginationFeature,
    rowSelectionFeature,
    rowSortingFeature,
    tableFeatures,
} from "@tanstack/react-table";
import type { DataGridColumnMeta } from "./columns/types";

/**
 * The one feature registry every DataGrid instance shares. Module-level so
 * its identity never changes; adding a feature here changes the types of every
 * table, column, row, and cell.
 */
export const dataGridFeatures = tableFeatures({
    rowSelectionFeature,
    cellSelectionFeature,
    columnFilteringFeature,
    globalFilteringFeature,
    rowSortingFeature,
    columnGroupingFeature,
    rowAggregationFeature,
    rowExpandingFeature,
    rowPaginationFeature,
    columnSizingFeature,
    columnResizingFeature,
    columnPinningFeature,
    columnOrderingFeature,
    columnVisibilityFeature,
    filteredRowModel: createFilteredRowModel(),
    sortedRowModel: createSortedRowModel(),
    groupedRowModel: createGroupedRowModel(),
    expandedRowModel: createExpandedRowModel(),
    paginatedRowModel: createPaginatedRowModel(),
    filterFns: {
        includesString: filterFn_includesString,
        equalsString: filterFn_equalsString,
        arrHas: filterFn_arrHas,
    },
    aggregationFns: { sum: aggregationFn_sum, count: aggregationFn_count },
    columnMeta: metaHelper<DataGridColumnMeta>(),
});

export type DataGridFeatures = typeof dataGridFeatures;
